import React, { useEffect, useState } from "react";
import "./video.scss";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchImage } from "../../api/newsService";

const Album = ({
  compact = false,
  excludeId,
  title,
  description,
  itemsPerPage: itemsPerPageProp,
}) => {
  const [page, setPage] = useState(0);
  const [postVideo, setPostVideo] = useState([]);

  useEffect(() => {
    getImage();
  }, []);

  useEffect(() => {
    setPage(0);
  }, [excludeId, compact]);

  const getImage = async () => {
    const res = await fetchImage();
    if (res?.data?.data?.lstImage) {
      setPostVideo(res.data.data.lstImage);
    }
  };

  const filteredAlbums = postVideo.filter((item) => item.id !== excludeId);
  const itemsPerPage = itemsPerPageProp ?? (compact ? 8 : 6);
  const numberOfEmployeesVisited = page * itemsPerPage;
  const totalPages = Math.ceil(filteredAlbums.length / itemsPerPage);

  const changePage = ({ selected }) => {
    setPage(selected);
  };

  return (
    <section
      className={`video_media video_media--album${compact ? " video_media--compact" : ""}`}
    >
      {(title || description) && (
        <div className="video_media__header video_media__header--compact">
          {title ? <h2>{title}</h2> : null}
          {description ? <p>{description}</p> : null}
        </div>
      )}

      <div className="video_media__grid">
        {filteredAlbums
          .slice(numberOfEmployeesVisited, numberOfEmployeesVisited + itemsPerPage)
          .map((employee) => (
            <Link
              to={`/thu-vien-hinh-anh/${employee.id}`}
              key={employee.id}
              className="video_media__album-card"
            >
              <div className="video_media__album-media">
                <img src={employee.image} alt={employee.title} />
                <div className="video_media__album-overlay" />
              </div>

              <div className="video_media__album-body">
                <h3>{employee.title}</h3>
                <span className="video_media__album-cta">
                  Xem album
                  <ArrowUpRight size={15} />
                </span>
              </div>
            </Link>
          ))}
      </div>

      {totalPages > 1 && (
        <ReactPaginate
          previousLabel={"Truoc"}
          nextLabel={"Sau"}
          pageCount={totalPages}
          onPageChange={changePage}
          containerClassName={"video_media__pagination"}
          previousLinkClassName={"video_media__page-link"}
          nextLinkClassName={"video_media__page-link"}
          disabledClassName={"video_media__page-disabled"}
          activeClassName={"video_media__page-active"}
          pageClassName={"video_media__page-item"}
          pageLinkClassName={"video_media__page-link"}
          previousClassName={"video_media__page-item"}
          nextClassName={"video_media__page-item"}
          breakClassName={"video_media__page-item"}
          breakLinkClassName={"video_media__page-link"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          forcePage={page}
        />
      )}
    </section>
  );
};

export default Album;
